import { render, staticRenderFns } from "./ModalDeleteLocationChannel.vue?vue&type=template&id=dfc93e08"
import script from "./ModalDeleteLocationChannel.vue?vue&type=script&lang=js"
export * from "./ModalDeleteLocationChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports